import React, { useContext, useEffect } from 'react';
import Container from '../common/components/Container/Container';
import Loading from '../common/components/Loading/Loading';
import Log from '../common/logging';
import { Provider } from '../config';
import { AuthenticationContext } from '../providers/AuthenticationContext';

import { FlowConfigContext } from '../providers/FlowConfigContext';
import WalletTokenEventPayload from '../services/events/walletTokenEventPayload';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import { Screens } from '../services/analytics/screens';

function WalletTokenSuccessScreen(): JSX.Element {
  const { initialized, flowSuccessful, flowFailed } = useContext(FlowConfigContext);
  const { getCurrentToken } = useContext(AuthenticationContext);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    const emitFlowResult = async () => {
      const tokenResult = await getCurrentToken();
      if (tokenResult.isFailed()) {
        tokenResult.logError();
        flowFailed({ provider: Provider.WALLET });
        return;
      }

      flowSuccessful(new WalletTokenEventPayload(tokenResult.success()));
    };

    emitFlowResult().catch((error) => Log.error('Unexpected error emitting wallet token result', error));
  }, [initialized]);

  return (
    <Container>
      <Loading dataTestId="IN_PROGRESS" />
    </Container>
  );
}
export default withRouteAnalytics(WalletTokenSuccessScreen, Screens.WALLET_TOKEN_SUCCESS);
